<template>
  <div class="charts-wrap">
    <el-row :gutter="10" class="charts-header" v-if="!nohader">
      <el-col class="charts-title font18" :span="10" v-if="title">
        {{title}}
        <el-tooltip class="item" effect="dark" :content="content" placement="top" :disabled="!content" v-show="content">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-col>
      <el-col class="charts-screen" :span="title ? 14 : 24">
        <slot name="filter"></slot>
      </el-col>
    </el-row>
    <div class="charts-content" v-loading="loading" :style="height ? 'height:' + height + 'px' : 'min-height:400px'" :class="!hasData && 'opacity0'" :id="id"></div>
    <p class="nodata" v-if="!hasData">暂无数据</p>
  </div>
</template>

<script>
import Echarts from 'echarts'
import Util from '@/common/util'
export default {
  name: 'Echarts',
  props: [
    'title',
    'header',
    'data',
    'content',
    'loading',
    'nohader',
    'height'
  ],
  data () {
    return {
      chart: '',
      hasData: true
    }
  },
  computed: {
    id () {
      return 'echarts-' + Util.uuid()
    }
  },
  watch: {
    data (val) {
      this.hasData = Boolean(val && val.series && val.series.length)
      if (this.hasData) {
        this.chart.setOption(val, true)
        this.$store.state.charts[this.id] = this.chart
      }
    }
  },
  method: {
  },
  mounted () {
    this.chart = Echarts.init(document.getElementById(this.id))
  }
}
</script>

<style scoped>
.opacity0 {
  opacity: 0;
}
.charts-wrap {
  background: #fff;
  border-radius: 3px;
  position: relative;
  /*box-shadow: 0 2px 3px hsla(0, 0%, 4%, 0.1), 0 0 0 1px hsla(0, 0%, 4%, 0.1);*/
}
.nodata{
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 12px;
  color: #909399;
  margin-left: -24px;
}
.charts-header {
  height: 49px;
  color: #4a4a4a;
  line-height: 49px;
  font-size: 14px;
  /*padding: 0 15px;*/
  /*border-bottom: 1px solid #e9e9e9;*/
  /* wwy add */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.charts-title {
  float: left;
  /* wwy add */
  overflow: hidden;
  height: 100%;
  color: #4a4a4a;
}
.charts-screen {
  float: right;
  line-height: 49px;
  height: 49px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.charts-button{
  float: right;
  margin-left: 3px;
  line-height: 49px;
}
.charts-button button{
  margin: 8px 3px;
}
.charts-screen .el-radio-group {
  margin-top: 11px;
  float: right;
  margin-left: 15px;
}
.charts-content {
  /*min-height: 400px;*/
  padding: 5px 0 15px 0;
  /*overflow: hidden;*/
  position: relative;
  z-index: 1;
}
.item{
  font-size: 14px;
  /*color: #666;*/
}
.el-icon-question {
  font-size: 14px;
  color: #ccc;
}
.el-icon-question:hover {
  color: #000;
}
</style>
